(function () {
  function removeTrackingParams() {
    var url = new URL(window.location.href);
    var dirty = false;
    ["srsltid"].forEach(function (key) {
      if (url.searchParams.has(key)) {
        url.searchParams.delete(key);
        dirty = true;
      }
    });
    if (dirty) {
      var cleanPath = url.pathname + (url.search ? "?" + url.searchParams.toString() : "") + url.hash;
      window.history.replaceState({}, document.title, cleanPath);
    }
  }

  function updateHeaderState() {
    if (window.scrollY > 24) {
      document.body.classList.add("frags-header-scrolled");
    } else {
      document.body.classList.remove("frags-header-scrolled");
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    removeTrackingParams();
    document.body.classList.add("frags-header-sticky");
    updateHeaderState();
    window.addEventListener("scroll", updateHeaderState, { passive: true });
  });
})();
